<span class="title">RENAME SHOW</span>
<div class="input-container">
  <div class="label">New show name</div>
  <input type="text" [(ngModel)]="name" />
</div>
<div class="apply-cancel-container">
  <a class="btn btn-cancel" (click)="cancel()">Cancel</a>
  <a class="btn btn-rename" [class.disabled]="!canRename()" (click)="rename()"
    >Rename</a
  >
</div>
